"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsts = __importStar(require("jsts"));
var Envelope_1 = __importDefault(require("./Envelope"));
var GeometryType_1 = require("./GeometryType");
/**
 * @category geom
 */
var Geometry = /** @class */ (function () {
    function Geometry() {
        this.id = 0;
        //#endregion
    }
    Object.defineProperty(Geometry.prototype, "type", {
        get: function () {
            return GeometryType_1.GeometryType.Unknown;
        },
        enumerable: true,
        configurable: true
    });
    Geometry.prototype.centroid = function () {
        return this.envelope().centroid();
    };
    Geometry.prototype.envelope = function () {
        var coordinates = this.coordinatesFlat();
        var _a = [
            Number.POSITIVE_INFINITY,
            Number.POSITIVE_INFINITY,
            Number.NEGATIVE_INFINITY,
            Number.NEGATIVE_INFINITY
        ], minx = _a[0], miny = _a[1], maxx = _a[2], maxy = _a[3];
        for (var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++) {
            var coordinate = coordinates_1[_i];
            if (minx > coordinate.x)
                minx = coordinate.x;
            if (miny > coordinate.y)
                miny = coordinate.y;
            if (maxx < coordinate.x)
                maxx = coordinate.x;
            if (maxy < coordinate.y)
                maxy = coordinate.y;
        }
        return new Envelope_1.default(minx, miny, maxx, maxy);
    };
    Geometry.prototype.area = function () {
        var tsGeom1 = this._ts();
        return tsGeom1.getArea();
    };
    Geometry.prototype.perimeter = function () {
        var tsGeom1 = this._ts();
        return tsGeom1.getLength();
    };
    Geometry.prototype.interiorPoint = function () {
        var tsGeom1 = this._ts();
        var interiorPoint = tsGeom1.getInteriorPoint();
        return { x: interiorPoint.getX(), y: interiorPoint.getY() };
    };
    Geometry.prototype.toJSON = function () {
        return {
            type: this.type,
            coordinates: this.coordinates()
        };
    };
    Geometry.prototype.clone = function (convert) {
        var geom = this._clone(convert);
        geom.id = this.id;
        return geom;
    };
    Geometry.prototype.toWKT = function () {
        var geomTS = this._ts();
        var writer = new jsts.io.WKTWriter();
        var wkt = writer.write(geomTS);
        return wkt;
    };
    Geometry.prototype.toWKB = function (bigEndian) {
        if (bigEndian === void 0) { bigEndian = false; }
        var WkbUtils = require("../shared/WkbUtils").default;
        return WkbUtils.geomToWKB(this, bigEndian);
    };
    Geometry.prototype.move = function (offsetX, offsetY) {
        this.forEachCoordinates(function (c) {
            c.x += offsetX;
            c.y += offsetY;
        });
    };
    Geometry.prototype.rotate = function (angle, origin) {
        if (origin === undefined) {
            origin = this.centroid();
        }
        this.forEachCoordinates(function (c) {
            var radius = Math.sqrt(Math.pow(c.x - origin.x, 2) + Math.pow(c.y - origin.y, 2));
            if (radius === 0) {
                return;
            }
            var currentAngle = Math.atan2(c.y - origin.y, c.x - origin.x);
            var newAngle = currentAngle + angle;
            c.x = origin.x + Math.round(radius * Math.cos(newAngle) * 1e8) / 1e8;
            c.y = origin.y - Math.round(radius * Math.sin(newAngle) * 1e8) / 1e8;
        });
    };
    //#region 
    Geometry.prototype.contains = function (geom) {
        var tsGeom1 = this._ts();
        var tsGeom2 = geom._ts();
        return tsGeom1.contains(tsGeom2);
    };
    Geometry.prototype.covers = function (geom) {
        var tsGeom1 = this._ts();
        var tsGeom2 = geom._ts();
        return tsGeom1.covers(tsGeom2);
    };
    Geometry.prototype.crosses = function (geom) {
        var tsGeom1 = this._ts();
        var tsGeom2 = geom._ts();
        return tsGeom1.crosses(tsGeom2);
    };
    Geometry.prototype.disjoint = function (geom) {
        var tsGeom1 = this._ts();
        var tsGeom2 = geom._ts();
        return !tsGeom1.intersects(tsGeom2);
    };
    Geometry.prototype.distance = function (geom) {
        var tsGeom1 = this._ts();
        var tsGeom2 = geom._ts();
        return tsGeom1.distance(tsGeom2);
    };
    Geometry.prototype.intersects = function (geom) {
        var tsGeom1 = this._ts();
        var tsGeom2 = geom._ts();
        return tsGeom1.intersects(tsGeom2);
    };
    Geometry.prototype.overlaps = function (geom) {
        var tsGeom1 = this._ts();
        var tsGeom2 = geom._ts();
        return tsGeom1.overlaps(tsGeom2);
    };
    Geometry.prototype.within = function (geom) {
        var tsGeom1 = this._ts();
        var tsGeom2 = geom._ts();
        return tsGeom1.within(tsGeom2);
    };
    Geometry.prototype.touches = function (geom) {
        var tsGeom1 = this._ts();
        var tsGeom2 = geom._ts();
        return tsGeom1.touches(tsGeom2);
    };
    Geometry._factory = new jsts.geom.GeometryFactory();
    return Geometry;
}());
exports.default = Geometry;
